var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcAddressBookMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 0c-.87 0-1.575.705-1.575 1.575v16.85c0 .87.705 1.575 1.575 1.575h12.235c.87 0 1.575-.705 1.575-1.575V5.712c0-.87-.705-1.575-1.575-1.575h-.348V1.575c0-.87-.705-1.575-1.575-1.575H4.19z",
    fill: "url(#a226699)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.013 2.413c0-.57.464-1.034 1.035-1.034h7.386a2.07 2.07 0 0 1 2.07 2.069H5.047a1.035 1.035 0 0 1-1.035-1.035z",
    fill: "url(#b226699)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.287 10.168c0-2.286 1.937-4.134 4.28-4.134 2.35 0 4.287 1.848 4.287 4.134 0 1.152-.425 2.221-1.124 3.128a11.06 11.06 0 0 1-2.793 2.555c-.245.158-.466.17-.734 0a10.847 10.847 0 0 1-2.792-2.555c-.7-.907-1.124-1.976-1.124-3.128zm2.87.128c0 .766.633 1.368 1.41 1.368.777 0 1.417-.602 1.417-1.368 0-.76-.64-1.392-1.417-1.392s-1.41.632-1.41 1.392z",
    fill: "url(#c226699)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a226699",
    x1: 2.615,
    y1: 0,
    x2: 2.615,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b226699",
    x1: 4.013,
    y1: 1.379,
    x2: 4.013,
    y2: 3.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c226699",
    x1: 6.287,
    y1: 6.034,
    x2: 6.287,
    y2: 15.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcAddressBookMenu);
export default __webpack_public_path__ + "static/media/icon-ic-address-book-menu.9c570bcf.svg";
export { ForwardRef as ReactComponent };